module.exports = __webpack_public_path__ + "img/check.3d177668.svg";